module.exports = __webpack_public_path__ + "img/contention-removable.e2c6668f.png";